import { User } from '@/shared/types/User';
import { Project } from '@/shared/types/Project';

export const checkHasEnoughMinutes = (user: User | null, project: Project) => {
  if (!user || !project || !project.duration) {
    return false;
  }
  const {
    minutes: { total: totalMinutes, used: usedMinutes },
  } = user.credits;
  if (project.translated_video_exists) {
    return true;
  }
  return Math.ceil(project.duration / 60) + usedMinutes <= totalMinutes;
};
